import React from 'react';

const IntegrationTabs = ({ activeSubTab, onSetActiveSubTab, activeTab }) => {
    if (activeTab === 'oauth-clients') {
        return null; // No tabs for OAuth clients
    }

    const tabs = [
        { id: 'register', label: 'Register', icon: 'fa-list' },
        { id: 'config', label: 'Configuration', icon: 'fa-cog' },
        { id: 'logs', label: 'Logs', icon: 'fa-history' },
        { id: 'stats', label: 'Statistics', icon: 'fa-chart-bar' }

    ];

    return (
        <div className="integration-tabs">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    className={`tab-btn ${activeSubTab === tab.id ? 'active' : ''}`}
                    onClick={() => onSetActiveSubTab(tab.id)}
                >
                    <i className={`fas ${tab.icon}`}></i>
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default IntegrationTabs;